module.exports = __webpack_public_path__ + "308bcd7735bb3188ceefd58a1fd33c10.svg";